import {Component, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {Yii} from "libraries/interfaces/Yii";
import {IDescriptionLabels} from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import {FIELD_DESCRIPTION_LABELS} from "app_sasha/shared/config/booking-wording";
import {ConfigFieldBuilderService} from "../config-field-builder.service";
import {IFieldSpecs} from "libraries/module/formbuilder/fields/interfaces/field-specs";
import {
    FARE_OPTIMISATION_ARRAY_FIELDS,
    FARE_OPTIMISATION_CHECKBOX_FIELDS, FARE_OPTIMISATION_NUMBER_FIELDS,
} from "../config";
import {ESashaPermissions} from "libraries/enums/e-sasha-permissions";
import {IMultiselectOptions} from "../../../../../libraries/module/formbuilder/fields/multiselect/multiselect.model";
import {
    ApiActionForFareOptimisation, ApiImpactOnFareType, ApiImpactOnLuggage,
    ApiServiceXStatus
} from "../../../../../libraries/service/resources/booking/interfaces/ApiSearchParameters";
import {HelperService} from "../../../services/helper.service";
import {BookingService} from "../../../../../libraries/service/booking/booking.service";
import {EnumsResourceService} from "../../../../../libraries/service/booking/enums/enums-resource.service";
import {RuntimeError} from "../../../../../libraries/service/error-tracing/runtime-error.model";
import {ErrorTracingService} from "../../../../../libraries/service/error-tracing/error-tracing.service";

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'fare-optimisation-fieldset',
    template: `
        <div class="sep-top">
            <collapsible [title]="fareOptimisationSearchTitle" [open]="open">
                <div class="sep-top">
                    <checkbox-field [fieldConfig]="formFields.hasFareOptimisation"></checkbox-field>
                </div>
                <div class="col-to-row-s-tb sep-top">
                    <div class="flex-1">
                        <multiselect
                                [fieldConfig]="formFields.actionForFareOptimisation"
                                [options]="actionForFareOptimisationOptions"></multiselect>
                    </div>
                    <div class="flex-1 sep-left">
                        <number [fieldConfig]="formFields.savingMin"></number>
                    </div>
                </div>
                <div class="col-to-row-s-tb sep-top">
                    <div class="flex-1">
                        <multiselect
                                [fieldConfig]="formFields.impactOnFareType"
                                [options]="impactOnFareTypeOptions"></multiselect>
                    </div>
                    <div class="flex-1 sep-left">
                        <multiselect
                                [fieldConfig]="formFields.impactOnLuggage"
                                [options]="impactOnLuggageOptions"></multiselect>
                    </div>
                </div>
            </collapsible>
        </div>
    `
})
export class FareOptimisationFieldsetComponent implements OnInit {
    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    @Input()
    public chipsToUpper: boolean;

    public readonly fareOptimisationSearchTitle: string = Yii.t('wui-sasha-js', 'Aérien - Optimisation tarifaire');

    public formFields: IFieldConfig;
    public fieldDescriptionLabels: { [key: string]: IDescriptionLabels } = FIELD_DESCRIPTION_LABELS;
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    public actionForFareOptimisationOptions: IMultiselectOptions[];
    public impactOnFareTypeOptions: IMultiselectOptions[];
    public impactOnLuggageOptions: IMultiselectOptions[];

    constructor(
        private readonly configFieldBuilderService: ConfigFieldBuilderService,
        private readonly helperService: HelperService,
        private readonly bookingService: BookingService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly enumsResourceService: EnumsResourceService,
    ) {
    }

    public ngOnInit(): void {
        this.enumsResourceService.listActionForFareOptimisation()
            .subscribe((typeList: string[]): void => {
                    this.actionForFareOptimisationOptions = typeList.map((type: string): IMultiselectOptions => {
                        return {
                            value: type,
                            label: this.bookingService.getTypeLabel(type),
                        };
                    });
                },
                (error: Error): void => {
                    this.errorTracingService.captureException(new RuntimeError("Unable to retrieve the list of action", error));
                });

        this.formFields = {
            ...this.configFieldBuilderService.buildFieldConfigCheckbox(this.form, FARE_OPTIMISATION_CHECKBOX_FIELDS),
            ...this.configFieldBuilderService.buildFieldConfigArray(this.form, FARE_OPTIMISATION_ARRAY_FIELDS),
            ...this.configFieldBuilderService.buildFieldConfigNumber(this.form, FARE_OPTIMISATION_NUMBER_FIELDS),
        };
        this.impactOnLuggageOptions = this.helperService.getMultiselectOptions(
            this.bookingService.impactOnLuggageLabels,
            Object.values(ApiImpactOnLuggage),
            true
        );
        this.impactOnFareTypeOptions = this.helperService.getMultiselectOptions(
            this.bookingService.impactOnFareTypeLabels,
            Object.values(ApiImpactOnFareType),
            true
        );
    }
}
